import { Mail, Phone } from "lucide-react";
import Image from "next/image";
import React from "react";
import MaxWidthWrapper from "components/Tiles/commonComponents/MaxWidthWrapper";

interface TitleIconProps {
  src: string;
  alt: string;
  width: number;
  height: number;
}

interface ContactCardProps {
  name: string;
  email?: string;
  phone?: string;
  avatarSrc?: string;
  role?: string;
  miniTitle?: string;
  title?: string;
  subtitle?: string;
  bgColor?: string;
  wrapperClass?: string;
  className?: string;
  titleIcon?: TitleIconProps;
}

const ContactCard: React.FC<ContactCardProps> = ({
  name,
  email,
  phone,
  avatarSrc,
  role,
  miniTitle,
  title,
  subtitle,
  bgColor,
  wrapperClass,
  className,
  titleIcon
}) => {
  return (
    <section id="contact-card" style={{ backgroundColor: bgColor, width: "100%" }} className={className}>
      <MaxWidthWrapper className={wrapperClass}>
        <div className="flex flex-col items-center justify-center">
          <div className="tile-title-container mb-8 text-center">
            {titleIcon && (
              <Image
                src={titleIcon.src}
                alt={titleIcon.alt}
                width={titleIcon.width}
                height={titleIcon.height}
                className="mb-4 inline"
              />
            )}
            {miniTitle && <h3 className="subby">{miniTitle}</h3>}
            {title && <h2 className="tile-main-header font-heading [text-wrap:balance]">{title}</h2>}
            {subtitle && <p className="tile-subtitle">{subtitle}</p>}
          </div>

          <div className="max-w-sm overflow-hidden rounded-xl bg-white shadow-md">
            <div className="flex items-center p-6">
              <div className="mr-4 flex-shrink-0">
                {avatarSrc ? (
                  <Image
                    src={avatarSrc}
                    alt={`${name}'s avatar`}
                    width={64}
                    height={64}
                    className="rounded-full object-cover"
                  />
                ) : (
                  <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gray-200">
                    <span className="text-2xl text-gray-500">{name.charAt(0)}</span>
                  </div>
                )}
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-800">{name}</h3>
                {role && <p className="text-sm text-gray-600">{role}</p>}
              </div>
            </div>
            <div className="bg-gray-50 px-6 py-4">
              {email && (
                <div className="mb-2 flex items-center">
                  <Mail className="mr-2 h-5 w-5 text-gray-500" />
                  <a href={`mailto:${email}`} className="text-blue-600 text-sm hover:underline">
                    {email}
                  </a>
                </div>
              )}
              {phone && (
                <div className="flex items-center">
                  <Phone className="mr-2 h-5 w-5 text-gray-500" />
                  <a href={`tel:${phone}`} className="text-blue-600 text-sm hover:underline">
                    {phone}
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </MaxWidthWrapper>
    </section>
  );
};

export default ContactCard;
